import { render, staticRenderFns } from "./rp-message.vue?vue&type=template&id=6a0d6432&"
import script from "./rp-message.vue?vue&type=script&lang=js&"
export * from "./rp-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports